import { BuiltInRoles, Role } from 'api/actions/roles/rolesActions.types';

export const isInstitutionRequired = ({ builtIn, key }: Role) => {
  if (builtIn) {
    return key === BuiltInRoles.superAdministrator || key === BuiltInRoles.umsAdministrator;
  }

  return false;
};
